import { Navigate, Route, Routes } from "react-router-dom";
import { admin } from "../globals/route-names";
import AdminDashboardPage from "../app/pannels/admin/components/admin-dashboard";
import AdminJobsPage from "../app/pannels/admin/components/admin-jobs";
import AdminUsersPage from "../app/pannels/admin/components/admin-users";
import AdminCompaniesPage from "../app/pannels/admin/components/admin-companies";
import AdminApplicationsPage from "../app/pannels/admin/components/admin-applications";
import AdminMediaPage from "../app/pannels/admin/components/admin-media";
import AdminSettingsPage from "../app/pannels/admin/components/admin-settings";
import AdminSiteContentPage from "../app/pannels/admin/components/admin-site-content";
import AdminBlogsPage from "../app/pannels/admin/components/admin-blogs";
import AdminCategoriesPage from "../app/pannels/admin/components/admin-categories";
import AdminAnalyticsPage from "../app/pannels/admin/components/admin-analytics";
import AdminAuditLogsPage from "../app/pannels/admin/components/admin-audit-logs";
import AdminSupportTicketsPage from "../app/pannels/admin/components/admin-support-tickets";
import AdminUpdatesPage from "../app/pannels/admin/components/admin-updates";
import Error404Page from "../app/pannels/public-user/components/pages/error404";

function AdminRoutes() {
    return (
        <Routes>
            <Route path={admin.INITIAL} element={<Navigate to={admin.DASHBOARD} replace />} />
            <Route path={admin.DASHBOARD} element={<AdminDashboardPage />} />
            <Route path={admin.JOBS_PENDING} element={<AdminJobsPage status="pending_review" title="Pending Job Review" />} />
            <Route path={admin.JOBS_ALL} element={<AdminJobsPage title="All Jobs" />} />
            <Route path={admin.USERS} element={<AdminUsersPage />} />
            <Route path={admin.EMPLOYERS} element={<AdminUsersPage role="employer" title="Employers" subtitle="Manage employer logins, status, and passwords" />} />
            <Route path={admin.CANDIDATES} element={<AdminUsersPage role="candidate" title="Candidates" subtitle="Manage candidate logins, status, and passwords" />} />
            <Route path={admin.COMPANIES} element={<AdminCompaniesPage />} />
            <Route path={admin.APPLICATIONS} element={<AdminApplicationsPage type="applications" />} />
            <Route path={admin.RESUMES} element={<AdminApplicationsPage type="resumes" />} />
            <Route path={admin.ANALYTICS} element={<AdminAnalyticsPage />} />
            <Route path={admin.MEDIA} element={<AdminMediaPage />} />
            <Route path={admin.SITE_CONTENT} element={<AdminSiteContentPage />} />
            <Route path={admin.BLOGS} element={<AdminBlogsPage />} />
            <Route path={admin.CATEGORIES} element={<AdminCategoriesPage />} />
            <Route path={admin.SETTINGS} element={<AdminSettingsPage />} />
            <Route path={admin.AUDIT_LOGS} element={<AdminAuditLogsPage />} />
            <Route path={admin.SUPPORT} element={<AdminSupportTicketsPage />} />
            <Route path={admin.UPDATES} element={<AdminUpdatesPage />} />
            <Route path="*" element={<Error404Page />} />
        </Routes>
    );
}

export default AdminRoutes;
